import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GoogleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_143_511"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="1"
          width="21"
          height="22"
        >
          <path
            d="M21.81 10.11H12.22V14.04H17.73C17.64 14.6 17.44 15.14 17.15 15.64C16.82 16.21 16.4 16.65 15.98 16.98C14.71 17.97 13.24 18.17 12.21 18.17C9.62 18.17 7.4 16.46 6.55 14.13C6.52 14.05 6.49 13.96 6.46 13.87C6.27 13.28 6.17 12.65 6.17 12C6.17 11.35 6.28 10.67 6.49 10.06C7.3 7.64 9.56 5.84 12.22 5.84C12.75 5.84 13.27 5.9 13.76 6.03C14.88 6.33 15.66 6.91 16.15 7.37L19.07 4.45C17.3 2.79 14.98 1.78 12.22 1.78C10.01 1.78 7.98 2.48 6.31 3.67C4.96 4.63 3.85 5.92 3.1 7.42C2.4 8.81 2.02 10.34 2.02 12C2.02 13.66 2.4 15.21 3.1 16.58C3.84 18.05 4.91 19.3 6.22 20.26C7.36 21.1 9.41 22.21 12.22 22.21C13.84 22.21 15.27 21.91 16.53 21.35C17.44 20.95 18.25 20.42 18.98 19.75C19.95 18.86 20.7 17.76 21.22 16.49C21.74 15.22 22.01 13.79 22.01 12.23C22.01 11.51 21.94 10.77 21.82 10.1L21.81 10.11Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_143_511)">
          <path
            d="M1.85 12.07C1.86 13.7 2.31 15.38 3 16.73C3.5 17.72 4.17 18.5 4.95 19.27L9.62 17.53C8.74 17.07 8.6 16.79 7.97 16.28C7.32 15.61 6.84 14.85 6.54 13.95C6.34 13.35 6.32 12.72 6.32 12.07H1.85Z"
            fill="url(#paint0_radial_143_511)"
          />
          <path
            d="M12.21 1.70999C11.75 3.36999 11.93 4.96999 12.21 5.90999C12.74 5.90999 13.26 5.97999 13.74 6.09999C14.86 6.39999 15.64 6.97999 16.13 7.43999L19.12 4.44999C17.35 2.78999 15.21 1.70999 12.21 1.70999Z"
            fill="url(#paint1_radial_143_511)"
          />
          <path
            d="M12.2 1.70001C9.94 1.70001 7.85 2.42001 6.14 3.64001C5.5 4.09001 4.92 4.61001 4.4 5.19001C4.26 6.49001 5.42 8.10001 7.71 8.08001C8.82 6.76001 10.46 5.91001 12.29 5.91001L12.22 1.70001C12.22 1.70001 12.22 1.70001 12.21 1.70001H12.2Z"
            fill="url(#paint2_radial_143_511)"
          />
          <path
            d="M19.67 12.54L17.65 13.96C17.56 14.52 17.36 15.06 17.07 15.56C16.74 16.13 16.32 16.57 15.9 16.9C14.64 17.89 13.16 18.09 12.14 18.09C11.08 19.93 10.89 20.86 12.21 22.35C13.84 22.35 15.29 22.05 16.57 21.48C17.49 21.07 18.31 20.54 19.05 19.86C20.03 18.96 20.8 17.84 21.32 16.55C21.84 15.26 22.12 13.81 22.12 12.23L19.66 12.54H19.67Z"
            fill="url(#paint3_radial_143_511)"
          />
          <path
            d="M12.06 9.96002V14.19H21.78C21.87 13.61 22.15 12.86 22.15 12.24C22.15 11.52 22.08 10.63 21.96 9.96002H12.07H12.06Z"
            fill="#3086FF"
          />
          <path
            d="M4.45 5.04001C3.85 5.71001 3.34 6.46001 2.93 7.27001C2.23 8.66001 1.85 10.34 1.85 12C1.85 12.02 1.85 12.05 1.85 12.07C2.16 12.67 6.11 12.56 6.31 12.07C6.31 12.05 6.31 12.02 6.31 12C6.31 11.32 6.42 10.82 6.63 10.21C6.88 9.45001 7.28 8.76001 7.78 8.16001C7.89 8.01001 8.2 7.69001 8.29 7.50001C8.32 7.43001 8.23 7.39001 8.22 7.36001C8.22 7.33001 8.09 7.36001 8.06 7.33001C7.97 7.26001 7.79 7.23001 7.68 7.19001C7.45 7.12001 7.06 6.97001 6.84 6.82001C6.16 6.33001 5.1 5.75001 4.45 5.04001Z"
            fill="url(#paint4_radial_143_511)"
          />
          <path
            d="M6.86 7.36001C8.44 8.34001 8.89 6.87001 9.94 6.41001L8.11 2.54001C7.44 2.83001 6.8 3.19001 6.21 3.61001C5.33 4.24001 4.55 5.00001 3.91 5.87001L6.85 7.37001L6.86 7.36001Z"
            fill="url(#paint5_linear_143_511)"
          />
          <path
            d="M7.5 17.23C5.38 18.01 5.05 18.04 4.85 19.38C5.22 19.75 5.62 20.1 6.05 20.41C7.19 21.25 9.39 22.36 12.2 22.36V18.01C11.15 18.01 10.31 17.73 9.44 17.24C9.23 17.12 8.84 17.44 8.65 17.3C8.38 17.1 7.73 17.47 7.49 17.23H7.5Z"
            fill="url(#paint6_linear_143_511)"
          />
          <path
            opacity="0.5"
            d="M10.97 17.88V22.29C11.36 22.34 11.77 22.37 12.2 22.37C12.63 22.37 13.05 22.35 13.45 22.31V17.92C13 18 12.57 18.03 12.2 18.03C11.78 18.03 11.36 17.98 10.96 17.89L10.97 17.88Z"
            fill="url(#paint7_linear_143_511)"
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial_143_511"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(7.18731 18.9056) rotate(-92.34) scale(10.1803 14.9773)"
          >
            <stop offset="0.14" stopColor="#1ABD4D" />
            <stop offset="0.25" stopColor="#6EC30D" />
            <stop offset="0.31" stopColor="#8AC502" />
            <stop offset="0.37" stopColor="#A2C600" />
            <stop offset="0.45" stopColor="#C8C903" />
            <stop offset="0.54" stopColor="#EBCB03" />
            <stop offset="0.62" stopColor="#F7CD07" />
            <stop offset="0.7" stopColor="#FDCD04" />
            <stop offset="0.77" stopColor="#FDCE05" />
            <stop offset="0.86" stopColor="#FFCE0A" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_143_511"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.0784 9.33149) scale(7.0686 9.1035)"
          >
            <stop offset="0.41" stopColor="#FB4E5A" />
            <stop offset="1" stopColor="#FF4540" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_143_511"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(13.7324 0.123008) rotate(151.02) scale(11.2996 15.3504)"
          >
            <stop offset="0.23" stopColor="#FF4541" />
            <stop offset="0.31" stopColor="#FF4540" />
            <stop offset="0.46" stopColor="#FF4640" />
            <stop offset="0.54" stopColor="#FF473F" />
            <stop offset="0.7" stopColor="#FF5138" />
            <stop offset="0.77" stopColor="#FF5B33" />
            <stop offset="0.86" stopColor="#FF6C29" />
            <stop offset="1" stopColor="#FF8C18" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_143_511"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(8.24822 19.8394) rotate(-127.45) scale(29.4749 10.8732)"
          >
            <stop offset="0.13" stopColor="#0CBA65" />
            <stop offset="0.21" stopColor="#0BB86D" />
            <stop offset="0.3" stopColor="#09B479" />
            <stop offset="0.4" stopColor="#08AD93" />
            <stop offset="0.48" stopColor="#0AA6A9" />
            <stop offset="0.57" stopColor="#0D9CC6" />
            <stop offset="0.67" stopColor="#1893DD" />
            <stop offset="0.77" stopColor="#258BF1" />
            <stop offset="0.86" stopColor="#3086FF" />
          </radialGradient>
          <radialGradient
            id="paint4_radial_143_511"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(9.98248 1.8618) rotate(96.62) scale(11.0331 15.2438)"
          >
            <stop offset="0.37" stopColor="#FF4E3A" />
            <stop offset="0.46" stopColor="#FF8A1B" />
            <stop offset="0.54" stopColor="#FFA312" />
            <stop offset="0.62" stopColor="#FFB60C" />
            <stop offset="0.77" stopColor="#FFCD0A" />
            <stop offset="0.86" stopColor="#FECF0A" />
            <stop offset="0.92" stopColor="#FECF08" />
            <stop offset="1" stopColor="#FDCD01" />
          </radialGradient>
          <linearGradient
            id="paint5_linear_143_511"
            x1="8"
            y1="2.5"
            x2="5.5"
            y2="6.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.32" stopColor="#FF4C3C" />
            <stop offset="0.6" stopColor="#FF692C" />
            <stop offset="0.73" stopColor="#FF7825" />
            <stop offset="0.88" stopColor="#FF8D1B" />
            <stop offset="1" stopColor="#FF9F13" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_143_511"
            x1="5"
            y1="21.5"
            x2="3.5"
            y2="13.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.23" stopColor="#0FBC5F" />
            <stop offset="0.31" stopColor="#0FBC5F" />
            <stop offset="0.37" stopColor="#0FBC5E" />
            <stop offset="0.46" stopColor="#0FBC5D" />
            <stop offset="0.54" stopColor="#12BC58" />
            <stop offset="0.7" stopColor="#28BF3C" />
            <stop offset="0.77" stopColor="#38C02B" />
            <stop offset="0.86" stopColor="#52C218" />
            <stop offset="0.92" stopColor="#67C30F" />
            <stop offset="1" stopColor="#86C504" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_143_511"
            x1="11.28"
            y1="20.5441"
            x2="13.7664"
            y2="20.5441"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0FBC5C" />
            <stop offset="1" stopColor="#0CBA65" />
          </linearGradient>
        </defs>
      </svg>
    </BaseIcon>
  ),
);

GoogleIcon.displayName = 'GoogleIcon';
